
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { 
  SidebarGroup, 
  SidebarGroupContent, 
  SidebarGroupLabel,
  SidebarMenu, 
  SidebarMenuButton, 
  SidebarMenuItem,
  useSidebar 
} from '@/components/ui/sidebar';
import { BookOpen, ChevronDown, ChevronRight, PlayCircle } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { Badge } from '@/components/ui/badge';
import { useSidebarNavigation } from '@/hooks/useSidebarNavigation';
import { UnifiedCourseNavigationSection } from './UnifiedCourseNavigationSection';

export const CourseNavigationSection = () => {
  // Use the new unified navigation component
  return <UnifiedCourseNavigationSection />;
};
